import { Edit } from "react-admin";
import * as React from "react";
import { LifestyleCreateForm } from "./LifestyleCreate";

export const LifestyleEdit = () => (
  <Edit>
    <LifestyleCreateForm />
  </Edit>
);
